import { useMutation, useQueryClient } from 'react-query'
import { get } from 'lodash'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { TOSHI_OS_ADD_POINTS_LOGS } from '../constants'

const retryRequest = async (id: number) => {
  // The response used to be discarded, so an already-granted row and a genuine resend
  // showed the same toast.
  return fetchAPI({
    method: 'post',
    path: `/toshi_os_add_points_logs/${id}/manual_retry`,
  })
}

export const useRetryRequest = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(retryRequest, {
    onSuccess: async (response) => {
      await queryClient.refetchQueries([TOSHI_OS_ADD_POINTS_LOGS])

      const alreadyGranted = get(response, 'data.result') === 'already_granted'

      toast({
        description: alreadyGranted
          ? t('views.admin.toshi_os_add_points_logs.services.already_granted')
          : t('views.admin.users.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
